import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const AccountingApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.ACCOUNTING}
      scope='accounting'
      envKey={apps[AppId.ACCOUNTING].runtimeEnvKey}
      entryPath='./AccountingApp'
      url={process.env.REACT_APP_ACCOUNTING_APP_DEV_PATH}
      cdnUrl={apps[AppId.ACCOUNTING].cdnUrl}
      appName={apps[AppId.ACCOUNTING].name}
      className={'accounting-app-class-wrapper'}
      appProps={{
        user,
        initialPath: apps[AppId.ACCOUNTING].path,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { AccountingApp }
